<form [formGroup]="brandingForm">
  <div class="field-container">
    <div
      class="color-icon"
      [style.background]="brandingForm.get('brandColor').value"
    ></div>
    <mat-form-field>
      <input
        matInput
        placeholder="{{
          'CUSTOMIZE_PARTNER.COLOR.COLOR_FIELD_TITLE' | translate
        }}"
        [colorPicker]="brandingForm.get('brandColor').value"
        formControlName="brandColor"
        (colorPickerChange)="brandingForm.get('brandColor').setValue($event)"
        [value]="brandingForm.get('brandColor').value"
        cpPosition="right"
        autocomplete="off"
      />
      <mat-error *ngIf="brandingForm.get('brandColor').hasError('pattern')">
        {{ 'CUSTOMIZE_PARTNER.COLOR.MISSING_HASH_ERROR' | translate }}
      </mat-error>
    </mat-form-field>
  </div>
  <div class="field-container">
    <mat-form-field>
      <mat-label>
        {{ 'CUSTOMIZE_PARTNER.COLOR.THEME_FIELD_TITLE' | translate }}
      </mat-label>
      <mat-select formControlName="uiTheme">
        <mat-option [value]="0">
          {{ 'CUSTOMIZE_PARTNER.COLOR.THEME_DARK' | translate }}
        </mat-option>
        <mat-option [value]="1">
          {{ 'CUSTOMIZE_PARTNER.COLOR.THEME_LIGHT' | translate }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <button mat-button (click)="submitForm()" [disabled]="brandingForm.invalid">
    {{ 'PACKAGE_PREVIEW_EDIT.DETAILS.SAVE_CTA_TEXT' | translate }}
  </button>
</form>
